/**
 * Backend error codes of `POST /dms/v1/telephony/calls` and `GET /dms/v1/telephony/voice-token`
 * that the call flow tells apart.
 */
export const TELEPHONY_CALL_ERROR_CODES = {
  USER_PHONE_MISSING: 'DMS-TE-CL-0001',
  LINE_UNAVAILABLE: 'DMS-TE-CL-0002',
  LINE_HAS_NO_NUMBER: 'DMS-TE-CL-0003',
  CALL_IN_PROGRESS: 'DMS-TE-CL-0006',
  LINE_NOT_FOUND: 'DMS-TE-LN-0001',
  PROVIDER_FAILED: 'DMS-TE-PR-0008',
  TELEPHONY_NOT_PROVISIONED: 'DMS-TE-PR-0001',
  BROWSER_CALLING_NOT_PROVISIONED: 'DMS-TE-PR-0014',
} as const;
